export const prevent_el_scroll = (elRef: any) => {

    elRef.addEventListener('touchmove', (e: any) => e.preventDefault())
    elRef.addEventListener("scroll", (e: any) => e.preventDefault())

    return () => {
        elRef.removeEventListener('touchmove', (e: any) => e.preventDefault())
        elRef.removeEventListener('scroll', (e: any) => e.preventDefault())
    }
}